exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".multiselect__tags{min-height:35px;height:35px}.multiselect__single{font-style:normal;font-weight:400;font-size:12px;line-height:16px;color:#272727}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/GenerateReportModal.vue"],"names":[],"mappings":"AACA,mBACE,gBAAiB,AACjB,WAAa,CACd,AACD,qBACE,kBAAmB,AACnB,gBAAoB,AACpB,eAAgB,AAChB,iBAAkB,AAClB,aAAe,CAChB","file":"GenerateReportModal.vue","sourcesContent":["\n.multiselect__tags {\n  min-height: 35px;\n  height: 35px;\n}\n.multiselect__single {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 16px;\n  color: #272727;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7533ebf8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Systems/GenerateReportModal.vue
// module id = 2091
// module chunks = 3